import { MtPuppyGuidePage } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import education from './assets/education.webp';
import grooming from './assets/grooming.webp';
import health from './assets/health.webp';
import preparation from './assets/preparation.webp';
import welcome from './assets/welcome.webp';
import type { Content, Images, Section } from './types';

export * from './types';

const images: Images = {
  welcomeImage: welcome,
  preparationImage: preparation,
  educationImage: education,
  healthImage: health,
  groomingImage: grooming,
};

export const MtPuppyGuidePageController: FC = () => {
  const { translate } = useTranslation();

  const sections = useMemo(() => {
    const translations: { [key: string]: any } =
      translate('mt.puppyGuide.sections', { returnObjects: true }) ?? {};

    return Object.entries(translations).map(([key, section]) => {
      const content: [string, Content][] = Object.entries(section.content);
      return {
        id: key,
        title: section.title,
        icon: section.icon,
        image: images[section.image as keyof Images],
        content: content.map(([, subSection]) => {
          return {
            id: subSection.id,
            title: subSection.title,
            content: subSection.content,
            cta: subSection.cta,
          };
        }),
      } as Section;
    });
  }, [translate]);

  return <MtPuppyGuidePage sections={sections} />;
};
